import React from 'react'

const SessionGradient = () => {
  return (
   <div>

    {/* for larger screen */}
       <div className='hidden md:block'>
          <div className='absolute top-[200px] left-[100px] rounded-[100px] rotate-1 blur-[150px] transform -translate-x- -translate-y-4 bg-gradient-to-r from from-[#00c3ffdb] to-[#FF29C3] h-[180px] w-[230px]'></div>
          <div className='absolute top-1/2 mt-14 right-[-90px] rounded-[100px] rotate-1 blur-[140px] transform -translate-x-56 -translate-y-24 bg-gradient-to-r from from-[#00C2FF] to-[#FF29C3] h-[180px] w-[230px]'></div>
      </div>

       <div>
      </div>
   </div>
  )
}

export default SessionGradient